import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/seo/Seo';

const countries = [
  {
    name: 'Türkiye',
    flag: '🇹🇷',
    delivery: 'Yurtiçi',
    cities: ['İstanbul', 'Ankara', 'İzmir', 'Gaziantep', 'Mersin', 'Kilis'],
    desc: 'Türkiye genelinde yurtiçi taşımacılık hizmeti sunuyoruz. Kilis merkezli operasyonumuzla tüm büyük şehirlere düzenli sefer düzenliyoruz.',
    bg: 'bg-red-50',
    accent: '#991b1b',
    img: 'https://readdy.ai/api/search-image?query=turkey%20istanbul%20ankara%20city%20skyline%20with%20logistics%20trucks%20on%20highway%2C%20professional%20transport%20route%2C%20modern%20infrastructure%2C%20high%20quality%20photography%2C%20warm%20tones&width=600&height=300&seq=ctr101&orientation=landscape',
  },
  {
    name: 'Suriye',
    flag: '🇸🇾',
    delivery: '1-2 Gün',
    cities: ['Şam', 'Halep', 'Lazkiye', 'Homs', 'Tartus'],
    desc: 'Kilis sınır kapısına olan yakınlığımız sayesinde Suriye\'ye en hızlı teslimatı gerçekleştiriyoruz. Sınır ötesi taşımacılıkta deneyimli ekibimizle güvenli hizmet.',
    bg: 'bg-green-50',
    accent: '#166534',
    img: 'https://readdy.ai/api/search-image?query=syria%20aleppo%20damascus%20city%20with%20cargo%20truck%20on%20highway%2C%20middle%20east%20transport%20route%2C%20professional%20photography%2C%20warm%20tones&width=600&height=300&seq=ctr102&orientation=landscape',
  },
  {
    name: 'Azerbaycan',
    flag: '🇦🇿',
    delivery: '2-3 Gün',
    cities: ['Bakü', 'Gence', 'Sumgayıt', 'Mingəçevir', 'Naxçıvan'],
    desc: 'Azerbaycan\'a karayolu taşımacılığında güvenilir çözümler sunuyoruz. Bakü başta olmak üzere tüm büyük şehirlere düzenli sefer.',
    bg: 'bg-orange-50',
    accent: '#c2410c',
    img: 'https://readdy.ai/api/search-image?query=azerbaijan%20baku%20city%20skyline%20with%20cargo%20truck%20on%20highway%2C%20caucasus%20transport%20route%2C%20professional%20photography%2C%20warm%20tones&width=600&height=300&seq=ctr103&orientation=landscape',
  },
  {
    name: 'Irak',
    flag: '🇮🇶',
    delivery: '2-4 Gün',
    cities: ['Bağdat', 'Erbil', 'Musul', 'Basra', 'Süleymaniye'],
    desc: 'Irak\'ın kuzeyinden güneyine kadar kapsamlı taşımacılık hizmeti sunuyoruz. Erbil ve Bağdat başta olmak üzere tüm bölgelere güvenli teslimat.',
    bg: 'bg-yellow-50',
    accent: '#854d0e',
    img: 'https://readdy.ai/api/search-image?query=iraq%20baghdad%20erbil%20city%20with%20cargo%20truck%20on%20highway%2C%20middle%20east%20logistics%20route%2C%20professional%20photography%2C%20warm%20tones&width=600&height=300&seq=ctr104&orientation=landscape',
  },
  {
    name: 'İran',
    flag: '🇮🇷',
    delivery: '3-5 Gün',
    cities: ['Tahran', 'Tebriz', 'İsfahan', 'Şiraz', 'Urmiye'],
    desc: 'İran\'ın büyük şehirlerine düzenli karayolu seferleri düzenliyoruz. Tebriz ve Tahran güzergahında hızlı ve güvenilir taşımacılık.',
    bg: 'bg-gray-50',
    accent: '#1a1a1a',
    img: 'https://readdy.ai/api/search-image?query=iran%20tehran%20tabriz%20city%20with%20cargo%20truck%20on%20highway%2C%20middle%20east%20transport%20route%2C%20professional%20photography%2C%20warm%20tones&width=600&height=300&seq=ctr105&orientation=landscape',
  },
  {
    name: 'Gürcistan',
    flag: '🇬🇪',
    delivery: '2-3 Gün',
    cities: ['Tiflis', 'Batum', 'Kutaisi', 'Rustavi', 'Zugdidi'],
    desc: 'Gürcistan\'a Kafkasya güzergahı üzerinden hızlı ve güvenli taşımacılık hizmeti sunuyoruz. Tiflis ve Batum\'a düzenli seferler.',
    bg: 'bg-rose-50',
    accent: '#9f1239',
    img: 'https://readdy.ai/api/search-image?query=georgia%20tbilisi%20batumi%20city%20with%20cargo%20truck%20on%20highway%2C%20caucasus%20transport%20route%2C%20professional%20photography%2C%20warm%20tones&width=600&height=300&seq=ctr106&orientation=landscape',
  },
  {
    name: 'Ermenistan',
    flag: '🇦🇲',
    delivery: '2-4 Gün',
    cities: ['Erivan', 'Gümrü', 'Vanadzor', 'Vagharshapat', 'Hrazdan'],
    desc: 'Ermenistan\'a Gürcistan transit güzergahı üzerinden taşımacılık hizmeti sağlıyoruz. Erivan başta olmak üzere tüm şehirlere teslimat.',
    bg: 'bg-amber-50',
    accent: '#92400e',
    img: 'https://readdy.ai/api/search-image?query=armenia%20yerevan%20city%20with%20cargo%20truck%20on%20highway%2C%20caucasus%20transport%20route%2C%20professional%20photography%2C%20warm%20tones&width=600&height=300&seq=ctr107&orientation=landscape',
  },
  {
    name: 'Rusya',
    flag: '🇷🇺',
    delivery: '5-8 Gün',
    cities: ['Moskova', 'St. Petersburg', 'Kazan', 'Krasnodar', 'Rostov'],
    desc: 'Rusya\'nın büyük şehirlerine uluslararası karayolu taşımacılığı hizmeti sunuyoruz. Moskova ve güney Rusya güzergahında düzenli seferler.',
    bg: 'bg-slate-50',
    accent: '#1e293b',
    img: 'https://readdy.ai/api/search-image?query=russia%20moscow%20city%20skyline%20with%20cargo%20truck%20on%20highway%2C%20international%20transport%20route%2C%20professional%20photography%2C%20warm%20tones&width=600&height=300&seq=ctr108&orientation=landscape',
  },
];

export default function CountriesPage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Seo
        title="Hedef Ülkeler | Global79 Lojistik"
        description="Global79 Lojistik ile Türkiye, Suriye, Azerbaycan, Irak, İran, Gürcistan, Ermenistan ve Rusya'ya düzenli yurtiçi, yurtdışı ve uluslararası taşımacılık hizmetleri."
        path="/hedef-ulkeler"
        keywords="hedef ülkeler lojistik, uluslararası nakliye güzergahları, Türkiye Suriye taşımacılık, Rusya lojistik"
        ogImage="/assets/images/hero-slide-3.png"
      />
      <Navbar />

      {/* Page Hero */}
      <section className="relative h-72 md:h-96 flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=middle%20east%20caucasus%20region%20map%20with%20logistics%20routes%20highlighted%2C%20trucks%20on%20highways%2C%20international%20transport%2C%20dramatic%20aerial%20view%2C%20high%20quality%20photography%2C%20ultra%20realistic&width=1920&height=600&seq=ctrhero02&orientation=landscape"
          alt="Hedef Ülkeler hero"
          className="absolute inset-0 w-full h-full object-cover object-center"
          fetchPriority="high"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
        <div className="relative z-10 text-center px-4">
          <span className="text-orange-400 text-sm font-bold uppercase tracking-widest mb-3 block">Güzergahlarımız</span>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Hedef Ülkeler
          </h1>
          <p className="text-gray-300 mt-4 text-base max-w-xl mx-auto">
            Yurtiçi, yurtdışı ve uluslararası seferlerimiz ile 8 ülkeye güvenli ve zamanında teslimat
          </p>
        </div>
      </section>

      {/* Countries */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-orange-500 text-sm font-bold uppercase tracking-widest mb-3 block">Hizmet Verdiğimiz Ülkeler</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Uluslararası <span className="text-orange-500">Taşımacılık</span>
            </h2>
          </div>

          <div className="flex flex-col gap-12">
            {countries.map((c, i) => (
              <div
                key={c.name}
                className={`flex flex-col ${i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center`}
              >
                {/* Image */}
                <div className="w-full lg:w-1/2 rounded-2xl overflow-hidden h-64">
                  <img src={c.img} alt={c.name} loading="eager" className="w-full h-full object-cover object-top" />
                </div>
                {/* Content */}
                <div className={`w-full lg:w-1/2 ${c.bg} rounded-2xl p-8`}>
                  <div className="flex items-center gap-4 mb-4">
                    <span className="text-5xl">{c.flag}</span>
                    <div>
                      <h3 className="text-3xl font-extrabold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>{c.name}</h3>
                      <span className="inline-flex items-center gap-1.5 bg-white rounded-full px-3 py-1 text-xs font-bold text-gray-600 mt-1">
                        <i className="ri-time-line text-orange-500" />
                        {c.delivery}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-5">{c.desc}</p>
                  <div>
                    <div className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Hizmet Verilen Şehirler</div>
                    <div className="flex flex-wrap gap-2">
                      {c.cities.map((city) => (
                        <span key={city} className="bg-white text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-full">
                          {city}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: '#f8f6f3' }}>
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Yük Göndermek mi İstiyorsunuz?
          </h2>
          <p className="text-gray-500 text-base mb-8 max-w-xl mx-auto">
            Hemen bizi arayın, size en uygun güzergah ve fiyat teklifini sunalım.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:05382323822"
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold px-10 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              Hemen Ara: 0 538 232 38 22
            </a>
            <a
              href="/iletisim"
              className="inline-flex items-center gap-2 border-2 border-gray-300 hover:border-orange-500 text-gray-700 hover:text-orange-500 font-bold px-10 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-right-line" />
              İletişim Sayfası
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
